const roles = {
    OfficeAdmin:'OfficeAdmin',
    Admin:'Admin' 
}

const customStyles = {
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (base) => ({
      ...base,
      maxHeight: "250px",
      overflowY: "auto",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "50px",
      borderRadius: "10px",
    }),
};

const statusList = [
  {
    value: 'Active',
    label: 'Active'
  } ,
  {
    value: 'Inactive',
    label: 'Inactive'
  } 
]

const modeTypeList = [
  {
    value: 'AIR',
    label: 'AIR'
  } ,
  {
    value: 'ROAD',
    label: 'ROAD'
  },
  {
    value: 'TRAIN',
    label: 'TRAIN'
  }  
]

const ContentsList = [
  {
    value: 'Biological Sample',
    label: 'Biological Sample'
  },
  {
    value: 'Stady Medicine',
    label: 'Stady Medicine'
  },
  {
    value: 'Lab Kit',
    label: 'Lab Kit'
  },
  {
    value: 'PCR Kit',
    label: 'PCR Kit'
  },
  {
    value: 'Other',
    label: 'Other'
  } 
]
const Liststatus=[
  {
    value:'Pending',
    label:'Pending'
  },
 {
    value:'Picked up',
    label:'Picked up'
  },
 {
    value:'In Transit',
    label:'In Transit'
  },
 {
    value:'Arrived at Hub',
    label:'Arrived at Hub'
  },
 {
    value:'Out for Delivery',
    label:'Out for Delivery'
  },
 {
    value:'Delivered',
    label:'Delivered'
  },
]

export {ContentsList, modeTypeList, customStyles, roles, statusList,Liststatus}
